import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import ProductCard from "./ProductCard";
import Header from "./Header";
import Cart from "./Cart"
import {generateCartItemsFrom} from "./Cart"
import "./Products.css";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
import Header from "./Header";
import "./Products.css";


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {

  // API
  const productsAPI = config.endpoint + "/products" ;

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  // States
  const [products,setProducts] = useState([]);
  // const [incCartItems,setIncCartItems] = useState([]);
  const[cartItems,setCartItems] = useState([]);
  const [isLoading,setIsLoading] = useState(false);

  const isLoggedIn = localStorage.getItem("username");
  const token = localStorage.getItem("token") ;

  // Effect
  useEffect(() => {
    // code to run after render goes here
    const updateCartItems = async () => {

      const products = await performAPICall() ;
      console.log('products',products);
      if(localStorage.getItem("token"))
      {
        const incompleteCartItems = await fetchCart(localStorage.getItem("token"));
        console.log('IncompleteCartItems',incompleteCartItems);
        const completeCartItems = await generateCartItemsFrom(incompleteCartItems,products);
        console.log("completeCartItems",completeCartItems);
        setCartItems(completeCartItems);
      }


    }

    updateCartItems() ;
      
     
  }, []);



  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */

 
  // API Call
  const performAPICall = async () => {

    try{

      // 
      setIsLoading(true);
      let response = await axios.get(productsAPI);
      let data = response.data ;
      console.log(data);
      setProducts(data);

      setIsLoading(false);
      return data ;

    }catch(e){
      setIsLoading(false);
      enqueueSnackbar(
        "Something went wrong. Check the backend console for more details",
        {
          variant: "error",
        }
      );
      return null ;
    }
   

  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {


    const searchAPI = productsAPI + `/search?value=${text}` ;
    
    try{
      // Loading-->Fetching and settin data-->NotLoading and Displaying -->Returning
      setIsLoading(true);
      const response = await axios.get(searchAPI);
      let data = response.data ;
      setProducts(data);
      setIsLoading(false);
      return data ;
      }
    catch(e) {
      // NotLoading-->Setting Products to empty array-->Returning
      setIsLoading(false);
      setProducts([]);
      console.log(e.response.status);
      return null ;

    }

  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  
  const [debounceTimer,setDebounceTimer] = useState(0) ;
  const debounceSearch = (event, debounceTimeout) => {

    const searchQuery = event.target.value ;
    if(debounceTimer) clearTimeout(debounceTimer);
    const newTimer= setTimeout(() => { performSearch(searchQuery) },500);
    setDebounceTimer(newTimer);

  };

  // Products JSX
  const productDisplay = products.length ?
    <Grid container spacing={2}  marginY="1rem" paddingX="1rem" >
      {
        products.map((product)=>{
          return (
            <Grid item xs={6} md={3} className="product-grid" key={product._id}>
              <ProductCard product={product} handleAddToCart={async () => addToCart(token,cartItems,products,product._id,1,{preventDuplicate:true})}></ProductCard>
            </Grid>
          );

        })
      }
    </Grid> : <Box className= "no-products">
      <SentimentDissatisfied />
      <p>No Products Found</p>
    </Box>  



/**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
 const fetchCart = async (token) => {

  const cartAPI = config.endpoint + "/cart" ;

  if (!token) return;

  try {
    // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
    const response = await axios.get(cartAPI,{
      headers: {
        'Authorization': `Bearer ${token}` 
      }
    });

    const data = response.data

    console.log(data);
    setCartItems(response);
    return data ;

  } catch (e) {
    if (e.response && e.response.status === 400) {
      enqueueSnackbar(e.response.data.message, { variant: "error" });
    } else {
      enqueueSnackbar(
        "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
        {
          variant: "error",
        }
      );
    }
    return null;
  }
};


// TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
/**
 * Return if a product already is present in the cart
 *
 * @param { Array.<{ productId: String, quantity: Number }> } items
 *    Array of objects with productId and quantity of products in cart
 * @param { String } productId
 *    Id of a product to be checked
 *
 * @returns { Boolean }
 *    Whether a product of given "productId" exists in the "items" array
 *
 */
const isItemInCart = (items, productId) => {

  return items.find((item) => item._id === productId) ? true : false ;
};

/**
 * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
 *
 * @param {string} token
 *    Authentication token returned on login
 * @param { Array.<{ productId: String, quantity: Number }> } items
 *    Array of objects with productId and quantity of products in cart
 * @param { Array.<Product> } products
 *    Array of objects with complete data on all available products
 * @param {string} productId
 *    ID of the product that is to be added or updated in cart
 * @param {number} qty
 *    How many of the product should be in the cart
 * @param {boolean} options
 *    If this function was triggered from the product card's "Add to Cart" button
 *
 * Example for successful response from backend:
 * HTTP 200 - Updated list of cart items
 * [
 *      {
 *          "productId": "KCRwjF7lN97HnEaY",
 *          "qty": 3
 *      },
 *      {
 *          "productId": "BW0jAAeDJmlZCF8i",
 *          "qty": 1
 *      }
 * ]
 *
 * Example for failed response from backend:
 * HTTP 404 - On invalid productId
 * {
 *      "success": false,
 *      "message": "Product doesn't exist"
 * }
 */
const addToCart = async (
  token,
  items,
  products,
  productId,
  qty,  
  options = { preventDuplicate: false }
) => {

    const cartAPI = config.endpoint + "/cart" ;

    if(!token)
    return enqueueSnackbar(
      "Login to add an item to the Cart",
      {
        variant: "warning",
      }) ;

    console.log(options.preventDuplicate);

    if(options.preventDuplicate && isItemInCart(items,productId))
    return enqueueSnackbar(
      "Item already in cart. Use the cart sidebar to update quantity or remove item.",
      {
        variant: "warning",
      }) ;
    
    try{

      const response  = await axios.post(cartAPI,{
        productId : productId , qty : qty 
      },{
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      const cartData = await generateCartItemsFrom(response.data,products);
      setCartItems(cartData) ;

    } catch(e) {
        console.log(e.message) ;
    }
    


};





























  return (
    <div>
      <Header hasHiddenAuthButtons={true}>

        {/* For desktop */}
        <TextField className="search-desktop"
          size= "small"
          placeholder ="Search for items/categories"
          InputProps={{
            className: "search",
            endAdornment: (
              <InputAdornment position="end">
                <Search color="primary"/>
              </InputAdornment>
            )
          }}
          name= "search"
          onChange ={(e) => debounceSearch(e,500)}
          variant="outlined"
        />
        
      </Header>

       {/* For mobile */}
       <TextField className="search-mobile"
          size= "medium"
          fullWidth
          placeholder ="Search for items/categories"
          InputProps={{
            className: "search",
            endAdornment: (
              <InputAdornment position="end">
                <Search color="primary"/>
              </InputAdornment>
            )
          }}
          name = "search"
          onChange ={(e) => debounceSearch(e,500)}
          variant="outlined"
        />

       <Grid container>
         <Grid item className="product-grid" md = {isLoggedIn ? 9 : 12}>
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>

           {isLoading ? <Box className="loading">
                                       <CircularProgress color="success"/>
                                       <p>Loading Products...</p> 
                                   </Box> 
                                   : productDisplay}

         </Grid>
         {isLoggedIn && <Grid item md={3}>
          <Cart products={products} items={cartItems} handleQuantity={addToCart}/>
         </Grid>
        }
        </Grid>
         {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}
      <Footer />
    </div>
  );
};

export default Products;


  // const productDummy = 
  // {
  // "name":"Tan Leatherette Weekender Duffle",
  // "category":"Fashion",
  // "cost":150,
  // "rating":4,
  // "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
  // "_id":"PmInA797xJhMIPti"
  // }

